import { Component, OnInit, Input } from "@angular/core";
import { DialogService } from "../dialog/index";
import { DialogComponent } from "../dialog/dialog.component";
import { DomSanitizer } from "@angular/platform-browser";
import { DataService } from "../../services/data.service"
import { InProductsService } from "../../services/inventory/in-products.service";
import { AuthenticationService } from "../../services/authentication.service";
import { environment } from "../../../../environments/environment";
import { ItemSearchComponent } from '../../component/item-search/item-search.component';
import { ProductSearchComponent } from '../../component/product-search/product-search.component';

export interface PrintItems {
  title: string;
  Items: any;
}

@Component({
  selector: 'app-barcode-print',
  templateUrl: './barcode-print.component.html',
  styleUrls: ['./barcode-print.component.css']
})
export class BarcodePrintComponent extends DialogComponent<PrintItems, boolean>
  implements PrintItems, OnInit {

  title: string;
  Items: any = [];
  Cols: any;
  href: string = "";
  Remark: string = "";
  scollable: boolean = false;
  barcode: string = ""
  cate: string = ""
  result: any = { result: false, RtnItem: {} };
  @Input() popup: boolean = true;
  loading: boolean = false
  Access: any;
  isedit: boolean = false;
  SelectAllItem: boolean = false;
  subcategoryLtist: any = [];

  constructor(dialogService: DialogService, private sanitizer: DomSanitizer, private ds: DataService, private ips: InProductsService, private aut: AuthenticationService) {
    super(dialogService);
  }

  ngOnInit() {
    this.Access = this.ds.Access["Barcode Print"];

    this.Cols = [
      { field: 'Selected', header: 'Selected', t: 'chekbox', e: false },
      { field: 'Barcode', header: 'Barcode', t: 'text', e: false },
      { field: 'Name', header: 'Name', t: 'text', e: false },
      { field: 'Unit', header: 'Unit', t: 'text', e: false },
      { field: 'Rate', header: 'Rate', t: 'decimal', e: false },
      { field: 'Copeis', header: 'Copies', t: 'Number', e: true }
    ]
    this.getSubcategory();

    if (this.Items && this.Items.length > 0) {
      var barcodes = "";
      for (let i of this.Items) {
        barcodes = barcodes + i.Barcode + ","
      }
      barcodes = barcodes.substring(0, barcodes.length - 1);
      var data = {
        Type: "barcodes",
        Value: barcodes,
        SellingPriceLevelId: this.ds.Settings.SellingPriceLevelId
      }
      this.loading = true;
      this.ips.barcodePrintField(data).subscribe(res => {
        if (res.Success) {
          for (let i of res.data) {
            for (let k of this.Items) {
              if (i.Barcode == k.Barcode) {
                i.Copeis = k.Copeis
              }
            }
          }
          this.Items = res.data;
          this.loading = false;
        }
      })
    }
    if (this.Items) {
      this.scollable = this.Items.length > 6;
    }
  }

  ok() {
    this.result.result = true;
    this.result.RtnItem = this.Items;
    this.close();
  }
  selectAll(e) {
    if (e.target.checked) {
      for (let i of this.Items) {
        i.Selected = true;
      }
    } else {
      for (let i of this.Items) {
        i.Selected = false;
      }
    }
  }
  sanitize(url: string) {
    return this.sanitizer.bypassSecurityTrustUrl(url);
  }
  validateCheck(): boolean {
    var v: number = 0;
    for (let i of this.Items) {
      if (i.Selected) v++;
    }
    return v == 0
  }
  BrcodePrint() {
    if (this.validateCheck()) {
      alert("Selected Item is Empty")
      return
    }
    if (environment.DirectBarcodePrint) {
      this.href = "iPOSJH:?type=1";
      for (let i of this.Items) {
        if (i.Selected) {
          this.href +=
            "&Barcode=" +
            i.Barcode +
            "&Name=" +
            i.Name +
            "&Copeis=" +
            i.Copeis +
            "&Rate=" +
            i.Rate +
            "&Unit=" +
            i.Unit +
            "&CostCode=" +
            i.CostCode +
            "&Remark=" +
            this.Remark +
            "&CompanyName=" +
            this.ds.Settings.LocationName +
            "&NoDecimal=" +
            this.ds.Settings.NoDecimal +
            "&Split=" +
            this.ds.Settings.SplitBarcode +
            "~";
        }
      }
      this.href = this.href.slice(0, -1);
      var dat = document.getElementById("Barcodep");
      dat.setAttribute("href", this.href)
      dat.click()
    } else {


      var data: any = { Type: 1, data: [] };
      for (let i of this.Items) {
        if (i.Selected) {
          i["Remark"] = this.Remark
          i["CompanyName"] = this.ds.Settings.LocationName
          i["Split"] = this.ds.Settings.SplitBarcode
          i["NoDecimal"] = this.ds.Settings.NoDecimal
          data.data.push(i)
        }
      }
      var d = {
        PrintData: JSON.stringify(data)
      }
      this.ips.saveasFile(d).subscribe(res => {
        if (res.Success) {
          var str = this.aut.baseUrl + '/' + res.data
          this.href = str
          var dat = document.getElementById("Barcodep");
          dat.setAttribute("href", "iPOSJH:" + this.href)
          dat.click()
        }
      })
    }
  }
  LablePrint() {
    if (this.validateCheck()) {
      alert("Selected Item is Empty")
      return
    }
    if (environment.DirectBarcodePrint) {
      this.href = "iPOSJH:?type=2";
      for (let i of this.Items) {
        if (i.Selected) {
          this.href +=
            "&Barcode=" +
            i.Barcode +
            "&Name=" +
            i.Name +
            "&Copeis=" +
            i.Copeis +
            "&Rate=" +
            i.Rate +
            "&Unit=" +
            i.Unit +
            "&CostCode=" +
            i.CostCode +
            "&Remark=" +
            this.Remark +
            "&CompanyName=" +
            this.ds.Settings.LocationName +
            "&NoDecimal=" +
            this.ds.Settings.NoDecimal +
            "&Split=" +
            this.ds.Settings.SplitBarcode +
            "~";
        }
      }
      this.href = this.href.slice(0, -1);
      var dat = document.getElementById("Barcodep");
      dat.setAttribute("href", this.href)
      dat.click()
    } else {
      var data: any = { Type: 2, data: [] };
      for (let i of this.Items) {
        if (i.Selected) {
          i["Remark"] = this.Remark
          i["CompanyName"] = this.ds.Settings.LocationName
          i["Split"] = this.ds.Settings.SplitBarcode
          i["NoDecimal"] = this.ds.Settings.NoDecimal
          data.data.push(i)

        }
      }
      var d = {
        PrintData: JSON.stringify(data)
      }
      this.ips.saveasFile(d).subscribe(res => {
        if (res.Success) {
          var str = this.aut.baseUrl + '/' + res.data
          this.href = str
          var dat = document.getElementById("Barcodep");
          dat.setAttribute("href", "iPOSJH:" + this.href)
          dat.click()
        }
      })
    }
  }

  barcodeKeydown(e) {
    if (e.keyCode == 115 && e.which == 115) {
      let d = this.dialogService
        .addDialog(ItemSearchComponent, { title: "Item search", message: "" })
        .subscribe(res => {
          if (res.result) {
            this.barcode = res.item.Barcode;
          }
        });
    }
    else if (e.keyCode == 13 && e.which == 13) {
      if (this.validateBarcode()) {
        this.loadItem("barcode", this.barcode);
      }

    }
  }

  validateBarcode(): boolean {
    if (this.barcode == "") {
      alert("Invalid Input");
      return false;
    }
    if (this.Items.length > 0) {
      for (let i of this.Items) {
        if (i.Barcode == this.barcode) {
          alert("Barcode Already Exist");
          return false;
        }
      }
    }
    return true
  }

  loadItem(type, code) {
    var data = {
      Type: type,
      Value: code,
      SellingPriceLevelId: this.ds.Settings.SellingPriceLevelId
    }
    this.loading = true;
    this.ips.barcodePrintField(data).subscribe(res => {
      if (res.Success) {
        for (let i of res.data) {
          this.Items.push(i);
        }
        this.selectChange();
        this.barcode = "";
        this.cate = "";
        this.loading = false
      }
    })
  }

  ClearPrint() {
    this.Items = [];
    this.barcode = "";
    this.cate = "";
    this.SelectAllItem = false;
  }

  listBarcode() {
    let d = this.dialogService
      .addDialog(ProductSearchComponent, { title: "Item search", message: "" })
      .subscribe(res => {
        if (res.result) {
          this.barcode = res.item.Barcode;
          document.getElementById("txtbarcode").focus();
        }
      });
  }

  saveEditAccessPremission(Access: any, edit: boolean): boolean {
    Access = this.ds.Access["Barcode Print"]
    if (edit) {
      return !Access.edit
    }
    else {
      return !Access.save
    }
  }

  cateKeydown(e) {
    if (e.keyCode == 13 && e.which == 13) {
      if (this.cate == "") {
        alert("Invalid Input")
      }
      else {
        this.Items = [];
        this.loadItem("cate", this.cate);
      }
    }
  }

  selectChange() {
    for (let i of this.Items) {
      if (i.Selected == false) {
        this.SelectAllItem = false;
        break;
      } else {
        this.SelectAllItem = true;
      }
    }
  }

  getSubcategory() {
    var FilterData: any = {
      Start: 0,
      FiterText: "",
      Limit: this.ds.Settings.MaxLimit,
      ItemTypeId: 1,
      CAType: 1
    };
    this.ips.getSubcategory(FilterData).subscribe(res => {
      this.subcategoryLtist = [];
      for (let i of res.data) {
        this.subcategoryLtist.push({
          Id: i.Id,
          Name: i.Code + " - " + i.Name,
          Code: i.Code
        });
      }
    }, (err) => console.error(err),
      () => {
      });
  }

  loadClick() {
    if (this.barcode == "" && this.cate == "") {
      alert("Invalid Input")
      return;
    }
    if (this.barcode != "" && this.cate != "") {
      alert("Enter only one Input")
      return;
    }

    var type = "barcode";
    if (this.barcode != "") {
      type = "barcode";
      if (this.Items.length > 0) {
        for (let i of this.Items) {
          if (i.Barcode == this.barcode) {
            alert("Barcode Already Exist");
            return;
          }
        }
      }
    } else {
      type = "cate";
      this.Items = [];
    }

    var code = type == "barcode" ? this.barcode : this.cate;
    this.loadItem(type, code);
  }

}



// WEBPACK FOOTER //
// /home/vsts/work/1/s/iPOSERP/src/app/shared/component/barcode-print/barcode-print.component.ts